@if (shouldDisplayFondsportrait()) {
  <wct-fondsportrait
    [class.sd-high-z]="comboHighZIndex"
    [userFundsSelectionVisible]="fondslistDisplayUserFondsButton" />
} @else {
  <wct-advanced-fond-list
    [class.sd-high-z]="comboHighZIndex"
    [redirectUrl]="fondslistRedirectUrl"
    [initialFundsVisibilitySelection]="fondslistInitialFundsVisibility"
    [userFundsSelectionVisible]="fondslistDisplayUserFondsButton"
    [controlComponentViaUrl]="fondslistControlViaUrl" />
}
